import { s as t } from "./index851.mjs";
var s = t, e = function(r, o) {
  return s[r] || (s[r] = o || {});
};
export {
  e as s
};
